export function preventZoom() {
    let viewportMeta = document.querySelector("meta[name='viewport']");
    if (!viewportMeta) {
        viewportMeta = document.createElement("meta");
        viewportMeta.setAttribute("name", "viewport");
        viewportMeta.setAttribute("content", "initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height, user-scalable=no");
        document.head.appendChild(viewportMeta);

        return () => {
            viewportMeta.remove();
        };
    }

    const initialContent = viewportMeta.getAttribute("content");
    viewportMeta.setAttribute("content", [initialContent, "user-scalable=no"].filter(Boolean).join(", "));
    return () => {
        viewportMeta.setAttribute("content", initialContent);
    };
}
